import Grid from '@mui/material/Grid';
import Download from '../../components/Download';
import UploadExcel from '../../components/UploadExcel';
// import TopCards from '../../components/sections/dashboard/top-cards';
import excel from '../../assets/images/excel.png'
import office from '../../assets/images/office365.png'
import { Link } from 'react-router-dom';
import WelcomeModal from '../../components/WelcomeModal';

const Dashboard = () => {
  return (
    <>
    <WelcomeModal />
      <div className='flex flex-col justify-center items-center h-[60vh] gap-8 w-full'>
        <div className=''>
          <h1 className='text font-bold  text-center text-3xl'>WELCOME</h1>
          <p className='text font-medium  text-center text-base mt-2'>To start please click to upload an excel file or click to manually create table</p>

          <div className='flex flex-wrap justify-center gap-4 MuiBox-root css-0'>
          <div className="transparent-background mt-10 w-full max-w-full md:w-[400px] rounded-4xl ">
              <div className="w-full flex flex-col h-[120px]">
                <div className="px-2 mt-2 flex justify-center items-center h-full">
                  <img src={excel} alt='excel icon' />
                </div>
              </div>
              <div className='w-full'>
                <UploadExcel />
              </div>
            </div>
            
            <div className="transparent-background mt-10 w-full max-w-full md:w-[400px] rounded-4xl ">
              <div className="w-full flex flex-col h-[120px]">
                <div className="px-2 mt-2 flex justify-center items-center h-full">
                  <img src={office} alt='excel icon' />
                </div>
              </div>
              <div className='w-full'>
                <Link to="/create-table">
                <button className='w-full gradient-background p-1 self-end font-bold text-base'>Create table manually</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className=''>
          <Download />
          {/* <Grid className='w-full'  container spacing={{ xs: 2.5, sm: 3, lg: 3.75 }}>
            <Grid item xs={12}>
              <TopCards />
            </Grid>
          </Grid> */}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
